import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import {
    IconButton,
    colors
} from '@material-ui/core';

import { makeStyles, withStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    }
}));

export const ContainedIconButton = withStyles((theme) => ({
    root: {
      color: theme.palette.getContrastText(colors.grey[300]),
      backgroundColor: colors.grey[300],
      '&:hover': {
        backgroundColor: colors.grey[400],
      },
    },
}))(IconButton);